import { httpClient } from "@services/api/httpClient";

const eligibleForAssessment = async (applicantId: number) => {
    
        const response = await httpClient.get("/offer-applicant/eligible-for-assessment", {
            params: {
                applicantId
            }
        });
        return response.data;
};

export default eligibleForAssessment;